















































































import Vue from 'vue';

import apiFetch from '../lib/api';

import Bubble from './Bubble.vue';
import Button from './Button.vue';
import Checkbox from './Checkbox.vue';
import FadeItem from './FadeItem.vue';
import Input from './Input.vue';

type Data = {
  displayFlyer: boolean;
  displayShare: boolean;
  email: string;
  flyerUrl: string;
  name: string;
  surname: string;
  newsletter: boolean;
  ranking: boolean;
  shareUrl: string;
  submitting: boolean;
  submitted: boolean;
};

export default Vue.extend({
  name: 'Form',
  components: {
    Bubble,
    Button,
    Checkbox,
    FadeItem,
    Input,
  },
  props: {
    id: String,
    points: Number,
  },
  data(): Data {
    return {
      displayFlyer: true,
      displayShare: false,
      email: '',
      flyerUrl: 'https://www.lidl.pt/pt/folhetos/promocoes-a-partir-de-25-05/view/flyer/page/4?utm_source=site_quizbot&utm_medium=banner&utm_campaign=20_kw22_fsfood&utm_content=fsfood',
      name: '',
      surname: '',
      newsletter: false,
      ranking: false,
      shareUrl: `https://www.facebook.com/sharer/sharer.php?u=${window.top.location.href}`,
      submitting: false,
      submitted: false,
    };
  },
  methods: {
    hideForm() {
      this.submitted = true;
    },
    async submitQuiz(e: Event): Promise<boolean> {
      e.preventDefault();

      try {
        this.submitting = true;

        const values = {
          email: this.email,
          name: this.name,
          surname: this.surname,
          consent_pp: true,
          consent_newsletter: this.newsletter,
          consent_rank: this.ranking,
          points: this.points,
        };

        await apiFetch(`submit/${this.id}`, {
          method: 'POST',
          body: JSON.stringify(values),
        });

        this.submitting = false;
        this.submitted = true;

        return true;
      } catch (response) {
        this.submitting = false;
        throw new Error(response);
      }
    },
  },
});
